export const PASSWORD_RESET_VALIDATE_TOKEN_ENDPOINT = '/api/v2/auth/password/reset/validate/';
export const PASSWORD_RESET_ENDPOINT = '/api/v2/auth/password/reset/confirm/';
